import { labelsToSelectOptions } from '@/utils/select-util/selectUtil'

interface SkuCodeModel {
  id?: number
  type: string
  code: string
}

const SKU_FORMAT = {
  Custom: 'CUSTOM',
  EAN: 'EAN',
  ISBN: 'ISBN',
  ITF: 'ITF',
  JAN: 'JAN',
  UPC: 'UPC',
  SupRef: 'SUPREF',
  CustomWeight: 'CUSTOM_WEIGHT',
  CustomPrice: 'CUSTOM_PRICE',
  Internal: 'INTERNAL'
} as const

type BarcodeFormat = (typeof SKU_FORMAT)[keyof typeof SKU_FORMAT]

/**
 * Dropdown labels, spelled for the merchant rather than echoing the wire value. The weighed
 * type is the one a merchant reads without knowing the codebase: it holds the PLU the scale
 * prints (DEC-2026-044), so it is named for what they hold in their hand, not for its enum.
 * Mirrors `SkuCodeTypeEnum::label()` on the backend.
 */
const SKU_TYPE_LABELS: Record<BarcodeFormat, string> = {
  [SKU_FORMAT.Custom]: 'Custom',
  [SKU_FORMAT.EAN]: 'EAN',
  [SKU_FORMAT.ISBN]: 'ISBN',
  [SKU_FORMAT.ITF]: 'ITF',
  [SKU_FORMAT.JAN]: 'JAN',
  [SKU_FORMAT.UPC]: 'UPC',
  [SKU_FORMAT.SupRef]: 'SupRef',
  [SKU_FORMAT.CustomWeight]: 'Weighed label (PLU)',
  [SKU_FORMAT.CustomPrice]: 'Custom Price',
  [SKU_FORMAT.Internal]: 'Internal barcode'
}

const SkuSelectOptions = labelsToSelectOptions(SKU_TYPE_LABELS)

export { SKU_FORMAT, SKU_TYPE_LABELS, SkuSelectOptions }
export type { BarcodeFormat, SkuCodeModel }
